export const colors = {
  themePrimary: '#00838f',
  themeSecundary: '#4c5c68',
};
